<template>
    <div v-if="isAvailable">
        <b-btn class="btn-card-action text-white bg-secondary my-1" @click="showModal">
            Снять с публикации<template v-if="purchase.flags.can_be_unpublished_till"><br />(До {{ getDateTimeFormat(purchase.flags.can_be_unpublished_till) }})</template>
        </b-btn>
        <b-modal :title="title" centered hide-footer no-close-on-backdrop no-close-on-esc @close="cancelModal" @cancel="cancelModal" :visible="isModalVisible">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <b-row class="py-2" no-gutters>
                <b-col class="fs-18 text-center">Вы действительно хотите снять извещение<br />№ {{ purchase.purchase_info.reg_number }} с публикации? </b-col>
            </b-row>
            <b-row class="mt-5">
                <b-col>
                    <ul>
                        <li class="fs-14 grey-color">Снятие извещения с публикации возможно только 1 раз.</li>
                        <li class="fs-14 grey-color">Снятие извещения с публикации приведет к отмене всех поданных на данное извещение предложений от поставщиков.</li>
                        <li class="fs-14 grey-color">Снятие извещения с публикации позволит Вам внести изменения в извещение, за исключением поля "Наименование закупочной сессии".</li>
                        <li class="fs-14 grey-color">
                            В момент снятия извещения с публикации, будет зафиксировано оставшееся рабочее время до окончания подачи предложений. В момент возобновления публикации, время окончания подачи предложений будет рассчитано на основании зафиксированного в момент снятия извещения с
                            публикации, оставшегося рабочего времени.
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <b-row class="mt-5">
                <b-col class="text-right">
                    <b-button type="reset" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelModal">Отмена</b-button>
                    <b-button type="submit" class="text-uppercase" variant="custom-danger" @click="unpublishPurchase">Снять с публикации</b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'cabinet-fl44-notice-card-unpublish-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isModalVisible: false,
            isDataSending: false,
            isLoading: false,
            timer: null
        };
    },
    created() {
        this.countdown();
        this.timer = setInterval(this.countdown, 1000);
    },
    methods: {
        countdown() {
            if (!this.isAvailable) {
                this.cancelModal();
                clearInterval(this.timer);
            }
        },
        showModal() {
            this.isModalVisible = true;
        },
        cancelModal() {
            this.isModalVisible = false;
        },
        async unpublishPurchase() {
            this.isDataSending = true;
            await this.$api.personal[this.purchase.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume'].unpublishPurchase(this.purchase.id, this.purchase.purchase_info.reg_number)
            this.cancelModal();
            this.$emit('action');
            this.isDataSending = false;
        }
    },
    computed: {
        title() {
            return `Снятие извещения № ${this.purchase.purchase_info.reg_number} с публикации`;
        },
        isAvailable() {
            return this.purchase.actions.unpublish && moment(this.purchase.flags.can_be_unpublished_till) - moment() > 0;
        }
    }
};
</script>
